import { handleActions, combineActions } from 'redux-actions'
import { fromJS } from 'immutable'

import translations from 'static/translations.json'

import * as UserActions from 'actions/user'
import * as SavedDashboardActions from 'actions/saved_dashboard'
import * as SavedChartsActions from 'actions/saved_charts'
import { getLocale } from 'utils/locale'

export const getTranslationsByLocale = (language, config = translations) => (
  Object.keys(config).reduce((acc, element) => ({ ...acc, [element]: config[element][language] }), {})
)

const locale = getLocale()

const englishTranslations = fromJS(getTranslationsByLocale('en', translations))

const buildI18n = loc => {
  const newTranslations = fromJS(getTranslationsByLocale(loc, translations))

  /* istanbul ignore next */
  return {
    get: (value, replacements = {}, forceEnglish = false) => {
      let translation = newTranslations.get(value) || englishTranslations.get(value) || value || ''

      if (forceEnglish) {
        translation = englishTranslations.get(value) || value || ''
      }

      return Object.keys(replacements)
        .reduce(
          (acc, key) => acc.replaceAll(`{${key}}`, replacements[key]),
          translation
        )
        .replace(/\{.*?\}/g, '')
    }
  }
}

export const initialState = {
  translations: buildI18n(locale)
}

export default handleActions({
  [UserActions.setUser]: (state, { payload: { languageShort } }) => (
    { ...state, translations: buildI18n(languageShort) }
  ),

  [combineActions(
    SavedDashboardActions.fetchSavedDashboardSuccess,
    SavedChartsActions.applySavedChartLocale
  )]: (state, { payload: { locale: loc } }) => (
    { ...state, translations: buildI18n(loc) }
  )
}, initialState)
